import { useModuleContext } from '@cognitranlimited/itis-web';
export var procedureApplicabilityModuleId = Symbol('procedureApplicabilityModule');
export var useProcedureApplicabilityContext = function () { return useModuleContext(procedureApplicabilityModuleId); };
